const FilasHome = () => import(/* webpackChunkName: "group-callcenter-cadastros" */ '../_views/FilasHome')
const CadastroFila = () => import(/* webpackChunkName: "group-callcenter-cadastros" */ '../_views/CadastroFila')
const AtualizarFila = () => import(/* webpackChunkName: "group-callcenter-cadastros" */ '../_views/AtualizarFila')

import { permissionsCadastroFila } from '../../../../../utils/permissionsCallCenter'

export default [
  {
    path: 'fila',
    meta: { requiresAuth: true, permissions: [...permissionsCadastroFila] },
    component: FilasHome,
    name: 'Fila',
  },
  {
    path: 'fila/criar',
    meta: {
      requiresAuth: true,
      permissions: [process.env.VUE_APP_ADMINISTRADOR, process.env.VUE_APP_CALLCENTER_CADASTRO_FILA_TOTAL],
    },
    component: CadastroFila,
    name: 'Fila/criar',
  },
  {
    path: 'fila/atualizar/:_id',
    meta: { requiresAuth: true, permissions: [...permissionsCadastroFila] },
    component: AtualizarFila,
    name: 'Fila/atualizar',
    props: true,
  },
]
